<template>
    <v-dialog v-model="show" persistent max-width="400">
        <v-card>
            <v-card-title class="headline">
                {{ title }}
            </v-card-title>
            <v-card-text>
                {{ text }}
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" text @click="close(true, true)">
                    {{ l("Save") }}
                </v-btn>
                <v-btn color="primary" text @click="close(false, true)">
                    {{ l("Discard") }}
                </v-btn>
                <v-btn color="primary" text @click="close(false, false)">
                    {{ l("Cancel") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    export default {
        data() {
            return {
                show: false,
                title: "",
                text: "",
                callback: null
            }
        },
        mounted() {
            this.$root.$on("savePrompt", (title, text, callback) => {
                this.show = true;
                this.title = title;
                this.text = text;
                this.callback = callback;
            });
        },
        methods: {
            close(save, close) {
                this.show = false;
                this.callback(save, close);
            },
            l(token, values) {
                return this.$root.l(token, values);
            }
        }
    }
</script>